export const modalActions = {
	CUSTOM: "CUSTOM",
	CREATE: "CREATE",
	DELETE: "DELETE",
	EDIT: "EDIT",
	MULTI_CREATE: "MULTI_CREATE",
	DISABLE: "DISABLE",
	UserLicenceAssignmentForm: "UserLicenceAssignmentForm",
};
